import React from 'react';
import { useSelector } from 'react-redux';
import AdvncShiftReportHeader from './AdvncShiftReportHeader';
import BillTypeSummaryPrint from './BillTypeSummaryPrint';
import DeliveryPartnerSummaryPrint from './DeliveryPartnerSummaryPrint';
import DeliveryBoysSummaryPrint from './DeliveryBoysSummaryPrint';
import DiscountSummaryPrint from './DiscountSummaryPrint';
import CategorySalesSummaryPrint from './CategorySalesSummaryPrint';
import TaxDetailsPrint from './TaxDetailsPrint';
import ShiftReceiptPrint from './ShiftReceiptPrint';
import ShiftDevicePrint from './ShiftDevicePrint';
import BillTypeTemplateSummaryPrint from './BillTypeTemplateSummaryPrint';
import StarHorizontalLine from '../../../../Single Components/StarHorizontalLine';
import './AdvanceSummaryFullPrintStyle.css';

const AdvanceSummaryFullPrint = () => {
  const template = useSelector((state) => state?.salesQuatationSlice?.setTemplate);

  // Add print-specific styles directly in component
  const printStyles = `
    @media print {
      .section-container {
        page-break-inside: avoid;
        break-inside: avoid;
      }
      .compact-table {
        font-size: 10px !important;
      }
    }
  `;

  return (
    <>
      <style>{printStyles}</style>
      <div className="advance-shift-print-page">
        <div className='flex-column advance-shift-report-table-container print-optimized'>
          <div className="section-container">
            <AdvncShiftReportHeader />
          </div>
          
          <div className="section-container">
            {template?.shiftReportReceiptTemplate === "template2" ?
              <BillTypeSummaryPrint/> :
              <BillTypeTemplateSummaryPrint/>
            }
          </div>
          
          <StarHorizontalLine/>
          
          <div className="section-container">
            <DeliveryPartnerSummaryPrint/>
          </div>
          
          <StarHorizontalLine/>
          
          <div className="section-container">
            <DeliveryBoysSummaryPrint/>
          </div>
          
          <StarHorizontalLine/>
          
          <div className="section-container">
            <DiscountSummaryPrint/>
          </div>
          
          <StarHorizontalLine/>
          
          <div className="section-container">
            <TaxDetailsPrint/>
          </div>
          
          <StarHorizontalLine/>
          
          <div className="section-container">
            <CategorySalesSummaryPrint/>
          </div>
          
          <StarHorizontalLine/>
          
          <div className="section-container">
            <ShiftReceiptPrint/>
          </div>
          
          <StarHorizontalLine/>
          
          <div className="section-container">
            <ShiftDevicePrint/>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdvanceSummaryFullPrint;